const OverallHealthLevelInfoData = window.SIMPL.OverallHealthLevelInfoData;

export default function GetOverallHealthLevelInfo(val,dataKey) {
    // jsonが読み込めていない場合orjsonに定義されていない場合
    if(OverallHealthLevelInfoData === null || OverallHealthLevelInfoData?.length <= 0) return null;

    // val/typeが未設定
    if(val === undefined || val === null || val === "") return null;

    var typeData = OverallHealthLevelInfoData.find(x => x.value === val);

    // 一致するものがない場合、デフォルトで黒を返す用に設定（色の場合のみ）
    if(typeData === undefined || typeData === null){
        if(dataKey === "color") return "#000000";
        if(dataKey === "zIndex") return 1;
    };

    return typeData[dataKey];
}